import React, { useEffect, useMemo, useRef, useState } from 'react'
import HighchartsReact from 'highcharts-react-official'
import Highcharts from 'highcharts'
import { Maybe } from 'graphql/jsutils/Maybe'

Highcharts.setOptions({
  chart: {
    style: {
      fontFamily: '"Droid Sans", sans-serif',
    },
  },
})

export type BarChartElementProps = {} & HighchartsReact.Props

const BarChartElement: React.FC<BarChartElementProps> = ({
  options,
  ...otherProps
}) => {
  const chartRef = useRef<HighchartsReact.RefObject>(null)

  return (
    <div>
      <HighchartsReact
        ref={chartRef}
        highcharts={Highcharts}
        options={options}
        {...otherProps}
      />
    </div>
  )
}

export default BarChartElement
